function getCustomHTML (html) {
  return html.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

function cleanHTMLFromEmptyBRs (messageHTML) {
  return messageHTML.replaceAll(/\n$/gmi, '').replaceAll(/(?:<br>){1,10}$/gmi, '')
}

function cleanHTMLQuoteReply (messageText) {
  return messageText?.replace(/<div class=(?:"|')gmail_quote(?:"|')>[\r\n]*(?:[\S\s]*)[\r\n]*<\/div>/g, '')
}

function cleanHTMLSignature (messageText) {
  // eslint-disable-next-line
  return messageText?.replace(/<div id=(?:"|\')boxes-footer(?:"|\')>[\r\n]*(?:[\S\s]*)[\r\n]*<\/div>/g, '')
}

export function fullCleanMessageHtml (html) {
  return getCustomHTML(
    cleanHTMLFromEmptyBRs(
      cleanHTMLQuoteReply(
        cleanHTMLSignature(html)
      )
    )
  )
}

const removeDangerousElements = (html) => {
  return html.replace(/position\s{0,}:\s{0,}absolute/g, '')
}
const addLinksToUrls = (html) => {
  return html
}

export const sanitizeHtml = (html) => {
  return addLinksToUrls(removeDangerousElements(html))
}
